'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeVirtualMenuListComponent = exports.getTimezoneProps = exports.formatTimezone = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactSelect = require('react-select');

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _lodash = require('lodash.sortby');

var _lodash2 = _interopRequireDefault(_lodash);

var _momentTimezone = require('moment-timezone');

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _reactVirtualized = require('react-virtualized');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var formatTimezone = exports.formatTimezone = function formatTimezone(tzString) {
  return '(GMT' + _momentTimezone2.default.tz(tzString).format('Z') + ') ' + tzString;
};

var getTimezoneProps = exports.getTimezoneProps = function getTimezoneProps(tzString) {
  var tz = _momentTimezone2.default.tz(tzString);
  var tzStringOffset = tz.format('Z').replace(':00', '').replace(':30', '.5');
  var x = tzStringOffset === 0 ? 0 : parseInt(tzStringOffset).toFixed(2);

  return {
    label: formatTimezone(tzString),
    value: '' + tzString,
    time: '' + x,
    offset: tz._offset
  };
};

var makeVirtualMenuListComponent = exports.makeVirtualMenuListComponent = function makeVirtualMenuListComponent(ListProps) {
  return function (props) {
    return _react2.default.createElement(_reactVirtualized.List, _extends({
      rowCount: props.children.length,
      style: {
        width: '100%'
      },
      rowHeight: 34.18,
      height: 300,
      width: 600,
      rowRenderer: function rowRenderer(_ref) {
        var key = _ref.key,
            index = _ref.index,
            style = _ref.style;

        return _react2.default.createElement(
          'div',
          { style: style, key: key },
          props.children[index]
        );
      }
    }, ListProps));
  };
};

var SelectTimezone = function (_React$Component) {
  _inherits(SelectTimezone, _React$Component);

  function SelectTimezone(props) {
    _classCallCheck(this, SelectTimezone);

    var _this = _possibleConstructorReturn(this, (SelectTimezone.__proto__ || Object.getPrototypeOf(SelectTimezone)).call(this, props));

    _this.state = {};

    var timeZones = _momentTimezone2.default.tz.names().map(function (tz) {
      return getTimezoneProps(tz);
    });

    _this.timeZones = (0, _lodash2.default)(timeZones, [function (el) {
      return -el.time;
    }]);
    return _this;
  }

  _createClass(SelectTimezone, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          onChange = _props.onChange,
          value = _props.value;

      if (this.props.guess && !value) {
        var guessed = _momentTimezone2.default.tz.guess();

        onChange && onChange(guessed);
        this.setState({
          selectedValue: guessed
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          _onChange = _props2.onChange,
          selectedTimezoneValue = _props2.value,
          _props2$isClearable = _props2.isClearable,
          isClearable = _props2$isClearable === undefined ? false : _props2$isClearable,
          className = _props2.className,
          restProps = _objectWithoutProperties(_props2, ['onChange', 'value', 'isClearable', 'className']);

      var selectClassName = className ? className : 'react-select-timezone';
      var selected = this.timeZones.find(function (_ref2) {
        var value = _ref2.value;

        return value === _this2.state.selectedValue;
      });

      return _react2.default.createElement(_reactSelect2.default, _extends({
        className: selectClassName,
        isClearable: isClearable,
        options: this.timeZones,
        isMulti: false,
        onChange: function onChange(option) {
          if (option) {
            _this2.setState({ selectedValue: option.value });
            _onChange && _onChange(option.value);
          } else {
            _this2.setState({ selectedValue: null });
            _onChange && _onChange(null);
          }
        },
        value: selected
      }, restProps));
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.value === undefined) {
        return null;
      }
      if (nextProps.value != prevState.selectedValue) {
        return {
          selectedValue: nextProps.value
        };
      }
      return null;
    }
  }]);

  return SelectTimezone;
}(_react2.default.Component);

exports.default = SelectTimezone;